import React from 'react';
import { Box, Typography, Card, CardContent, Button } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import CostItemTemplates from '../components/CostItemTemplates';

const CostItems: React.FC = () => {
  const { agencySlug } = useParams<{ agencySlug: string }>();
  const navigate = useNavigate();
  const { agency } = useAuth();
  const planName = (agency?.subscription?.planName || agency?.subscriptionPlan || 'Free').toLowerCase();
  const hasCommissionAccess = ['professional', 'agency premium', 'premium', 'enterprise', 'demo'].includes(planName);

  if (!agencySlug) {
    return (
      <Box p={3}>
        <Typography color="text.secondary">Agency not found.</Typography>
      </Box>
    );
  }

  if (!hasCommissionAccess) {
    return (
      <Box p={3}>
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Cost Items
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 2 }}>
              Cost items for property sales are available on the Agency Premium plan. Upgrade your
              subscription to define default cost items and add them to property cost of sales.
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate(`/agencies/${agencySlug}/subscription`)}
            >
              View subscription
            </Button>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <Typography variant="h4" component="h1" gutterBottom>
        Cost Items
      </Typography>
      <CostItemTemplates agencySlug={agencySlug} showTitle={false} />
    </Box>
  );
};

export default CostItems;
